import { render, staticRenderFns } from "./TheSection.vue?vue&type=template&id=472d3b08&scoped=true&"
import script from "./TheSection.vue?vue&type=script&lang=js&"
export * from "./TheSection.vue?vue&type=script&lang=js&"
import style0 from "./TheSection.vue?vue&type=style&index=0&id=472d3b08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d3b08",
  null
  
)

export default component.exports